export class SlagMeltingPoint {
  constructor({
    id = null,
    planDate = ``,
    shift = '',
    plant = '',
    furnaceName = ``,
    furnaceBatch = ``,
    resultOne = ``,
    resultTwo = ``,
    resultThree = '',
    resultFour = '',
    slagMeltingPoint = '',
    onePoint = '',
    twoPoint = '',
    threePoint = '',
    slagMelting = '',

  } = {}) {
    this.id = id;
    this.planDate = planDate;
    this.shift = shift;
    this.plant = plant;
    this.furnaceName = furnaceName;
    this.furnaceBatch = furnaceBatch;
    this.resultOne = resultOne;
    this.resultTwo = resultTwo;
    this.resultThree = resultThree;
    this.resultFour = resultFour;
    this.slagMeltingPoint = slagMeltingPoint;
    this.onePoint = onePoint;
    this.twoPoint = twoPoint;
    this.threePoint = threePoint;
    this.slagMelting = slagMelting;
  }
}
export function gridFields() {
  return Object.freeze([

    {
      key: 'planDate',
      label: 'lbl.slagMeltingPoint.planDate',
      sortable: true,
      form: {
        type: 'datepicker'
      }
    },
    {
      key: 'plant',
      label: 'lbl.location.area',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'shift',
      label: 'lbl.slagMeltingPoint.shift',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'furnaceName',
      label: 'lbl.slagMeltingPoint.furnaceName',
      sortable: true,
      form: {
        type: 'select',
        options: [
          { value: '1', text: 'opt.furnaceNumber1' },
          { value: '2', text: 'opt.furnaceNumber2' },
          { value: '3', text: 'opt.furnaceNumber3' },
          { value: '4', text: 'opt.furnaceNumber4' },
          { value: '5', text: 'opt.furnaceNumber5' },
          { value: '6', text: 'opt.furnaceNumber6' },
          { value: 'NO', text: '无' },
        ]
      }
    },
    {
      key: 'furnaceBatch',
      label: 'lbl.slagMeltingPoint.furnaceBatch',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'resultOne',
      label: 'lbl.slagMeltingPoint.resultOne',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'resultTwo',
      label: 'lbl.slagMeltingPoint.resultTwo',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'resultThree',
      label: 'lbl.slagMeltingPoint.resultThree',
      sortable: true,
      form: {
        type: 'input'
      }
    },

    {
      key: 'resultFour',
      label: 'lbl.slagMeltingPoint.resultFour',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'slagMeltingPoint',
      label: 'lbl.slagMeltingPoint.slagMeltingPoint',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'onePoint',
      label: 'lbl.slagMeltingPoint.onePoint',
      sortable: true,
      form: {
        type: 'input'
      }
    },

    {
      key: 'twoPoint',
      label: 'lbl.slagMeltingPoint.twoPoint',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'threePoint',
      label: 'lbl.slagMeltingPoint.threePoint',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'slagMelting',
      label: 'lbl.slagMeltingPoint.slagMelting',
      sortable: true,
      form: {
        type: 'input'
      }
    }
  ]);
}

export const fields = Object.freeze(Object.keys(new SlagMeltingPoint()).map(i => 'entity.' + i));
export const filterFields = [
  'filter.startDateFilter',
  'filter.endDateFilter',
  'filter.shiftFilter',
  'filter.plant',
  'filter.furnaceNameFilter',
  'filter.furnaceBatchFilter',

];
export const filter = {
  'startDateFilter': "",
  'endDateFilter': "",
  'plant': "",
  'shiftFilter': "",
  'furnaceNameFilter': "",
  'furnaceBatchFilter': "",
};

